import { DefElement, getProperty, IDefObject } from "csi/utility/defUtility";

class Parameter implements IDefObject {
	m_id: string;
	m_typeAttr: string;
	m_value: string;

	isValid(): boolean {
		return !!this.m_id;
	}

	constructor(element?: DefElement) {
		this.m_id = getProperty(element, "Id");
		this.m_typeAttr = getProperty(element, "Type");
		this.m_value = getProperty(element, "Value");
	}
}

export = Parameter;
